export default {
  new_pass: "New Password",
  password: "Password",
  sign_in: "sign in",
  log_in: "Log in",
  back_login: "Back to log in",
  sign_up: "Request Access",
  enter_details: "please enter your details",
  login_trio: "Sign in to Trio",
  remember_me: "Remember me",
  forgot_pass: "Forgot password",
  enter_business_email: "Email Address",
  login_sso: "Login with SSO (Coming Soon)",
  reset_password: "Reset Password",
  close: "close",
  check_email: "Check Your Email!",
  resend_email: "Resend email",
  resend_email_in_mail: "Resend email (In {{time}} seconds)",
  confirm_password: "Confirm New Password",
  save_changes: "save changes",
  password_changed: "Password changed!",
  pleaseـenterـdetails: "Sign in to continue to",
  reset_password_link_email:
    "Password reset instructions have been sent to your email address.",
  changed_pass_successfully:
    "Your password has been successfully changed. Go back to the login page to use your new password.",
  define_new_strong_password: "Please define a new and strong password.",
  no_worries_resent_instructions:
    "Enter the email associated with your account to receive a link to reset your password.",
  sign_up_title: "Sign up to Trio",
  sign_up_first_sub_title: "Let us know you a little more",
  sign_up_sucond_sub_title: "Complete your sign up",
  sign_up_texts_title: "Manage Better & Faster",
  sign_up_texts_first:
    "Enroll & manage devices with a single click, allowing IT admins to better focus on security.",
  sign_up_texts_second:
    "Empower your teams by providing them with tools they need.",
  sign_up_texts_third:
    "No more worries about data migration. Effortlessly integrate with an infinite number of applications.",
  sign_up_texts_Security: "Security",
  sign_up_texts_migration: "Migration",
  sign_up_texts_management: "Management",
  sign_up_texts_analyzing: "Analyzing",
  sign_up_confirm_password: "Confirm Password",
  sign_up_country: "Where your company located?*",
  agreement_first_clue: "By creating your account, you agree to the Trio",
  agreement_second_clue: "Privacy Policy",
  agreement_third_clue: "Terms of Service",
  create_my_accont: "Create my account",
  sign_up_done_title: "One More Step",
  sign_up_done_sub_title_first_clue: "We sent verification email to",
  sign_up_done_sub_title_second_clue:
    ", please check your inbox to complete your sign up.",
  verified_title: "Verified Successfully",
  verified_subtitle:
    "Your account has been activated. Enjoy easy, fast, and secure device management.",
  start_using_trio: "Start Using Trio",
  verified_unsuccess_title: "Verified Unsuccessfully",
  verified_unsuccess_subtitle: "Token is not valid.",
  verified_back_signup: "Back to signup",
  enter_code: "Enter Code",
  enter_your: "Enter your",
  authenticator_app: "Authenticator App",
  code: "code",
  we_sent_code_to: "The code is emailed to",
  need_account: "Need an account?",
  log_in_sso: "Login with SSO (Coming soon)",
  send_code: "Send code via Email",
  need_help: "Need help?",
  contact_us: "Contact us",
};
